'use strict';
async function finishBreathe(){
  clearInterval(breathIv); const passId = S.sheet && S.sheet.pass; const mins = Math.min(5, Math.max(1, Math.round(S.breathT / 60)));
  S.sheet = null;
  if (S.demo){ S.me.minutes = (S.me.minutes || 0) + mins; S.me.sessions = (S.me.sessions || 0) + 1; S.community += mins; render(); toast('+10 points. Nicely done.'); return; }
  try {
    const b = S.fs.batch();
    b.update(S.fs.doc('members/' + S.uid), { minutes: FV().increment(mins), sessions: FV().increment(1), lastRest: FV().serverTimestamp() });
    b.set(S.fs.doc('stats/community'), { minutes: FV().increment(mins) }, { merge: true });
    await b.commit();
    if (passId) await S.fs.doc('passes/' + passId).update({ redeemed: true, redeemedAt: FV().serverTimestamp() });
    toast('+10 points. ' + mins + ' rest minute added to the slommunity.');
  } catch (e) { toast('Couldn’t save that rest. Slow downs count once a minute.'); }
  render();
}
async function post(){
  const n = mySloth(); if (!n || !S.moods.length) return;
  const l = S.moods.map((m) => m.toLowerCase()); const what = (l.length === 1 ? l[0] : l.slice(0, -1).join(', ') + ' and ' + l[l.length - 1]);
  const rec = { uid: S.uid, name: S.me.displayName, slothNo: n, what: what.charAt(0).toUpperCase() + what.slice(1) + '.', ponder: S.ponder.trim().slice(0, 140), zzz: {} };
  S.moods = []; S.ponder = '';
  if (S.demo){ rec.id = 'local' + Date.now(); rec.at = Date.now(); S.posts.unshift(rec); render(); toast('Posted (preview only).'); return; }
  try { rec.at = FV().serverTimestamp(); await S.fs.collection('posts').add(rec); toast('Posted. Let the Zzz roll in.'); } catch (e) { toast('Couldn’t post that. Try again.'); }
  render();
}
async function vote(id){
  const p = S.posts.find((x) => x.id === id); if (!p || p.uid === S.uid || !mySloth()) return;
  const now = !(p.zzz && p.zzz[S.uid]);
  if (S.demo){ p.zzz = Object.assign({}, p.zzz, { [S.uid]: now }); render(); return; }
  try { await S.fs.doc('posts/' + id).update({ ['zzz.' + S.uid]: now }); } catch (e) { toast('Couldn’t record that Zzz.'); }
}
async function findRecipient(){
  const n = parseInt(S.send.num, 10);
  if (!(n >= 1 && n <= TOTAL)){ toast('Enter a sloth number from 1 to 10,000.'); return; }
  if (n === mySloth()){ toast('That’s your own sloth. Treat yourself to a slow down instead.'); return; }
  if (S.demo){ toast('Sending passes works once the database is connected.'); return; }
  try {
    const r = await S.fs.doc('register/' + n).get();
    if (!r.exists){ toast('No one has adopted No. ' + pad(n) + ' yet.'); return; }
    const m = await S.fs.doc('members/' + r.data().uid).get();
    S.send.to = r.data().uid; S.send.toNo = n; S.send.toName = (m.exists && m.data().displayName) || SL[n - 1].name; renderSheetOnly();
  } catch (e) { toast('Couldn’t look that up. Try again.'); }
}
async function sendPass(){
  const sd = S.send; if (!sd.to || S.demo) return;
  try { await S.fs.collection('passes').add({ from: S.uid, fromName: S.me.displayName, fromSlothNo: S.me.slothNo, to: sd.to, type: sd.type, note: sd.note.slice(0, 240), at: FV().serverTimestamp(), redeemed: false }); S.sheet = null; render(); toast('Your ' + PASSES[sd.type][0] + ' is drifting over to ' + sd.toName + '.'); sd.to = null; sd.num = ''; }
  catch (e) { toast('Couldn’t send the pass. Try again.'); }
}
const AUTH_ERRORS = { 'auth/email-already-in-use': 'That email already has an account. Sign in instead.', 'auth/invalid-credential': 'That email and password don’t match.', 'auth/wrong-password': 'That email and password don’t match.', 'auth/user-not-found': 'No account with that email. Create one instead.', 'auth/weak-password': 'Use at least 6 characters for your password.', 'auth/invalid-email': 'That email doesn’t look right.', 'auth/popup-closed-by-user': 'The Google window was closed before signing in.', 'auth/too-many-requests': 'Too many tries. Wait a minute and try again.' };
async function emailAuth(form){
  const email = form.querySelector('#sp-email').value.trim(), pass = form.querySelector('#sp-pass').value; S.err = '';
  if (S.demo){ S.authed = true; S.uid = 'demo'; S.sheet = { type: 'profile' }; render(); return; }
  try { if (S.joinMode === 'signup') await S.auth.createUserWithEmailAndPassword(email, pass); else await S.auth.signInWithEmailAndPassword(email, pass); }
  catch (e) { S.err = AUTH_ERRORS[e.code] || 'Couldn’t sign you in. Try again.'; renderSheetOnly(); }
}
async function googleAuth(){
  if (S.demo){ S.authed = true; S.uid = 'demo'; S.sheet = { type: 'profile' }; render(); return; }
  try { await S.auth.signInWithPopup(new window.firebase.auth.GoogleAuthProvider()); }
  catch (e) { S.err = AUTH_ERRORS[e.code] || 'Couldn’t sign in with Google. Try email instead.'; renderSheetOnly(); }
}
async function resetPass(){
  const el = root.querySelector('#sp-email'); const email = el && el.value.trim();
  if (!email){ S.err = 'Type your email above first.'; renderSheetOnly(); return; }
  try { await S.auth.sendPasswordResetEmail(email); toast('Check your inbox for a reset link.'); } catch (e) { S.err = AUTH_ERRORS[e.code] || 'Couldn’t send a reset link.'; renderSheetOnly(); }
}

// ---------- Actions ----------
let toastT = null;
function toast(msg){ const t = root.querySelector('#sp-toast'); t.textContent = msg; t.hidden = false; clearTimeout(toastT); toastT = setTimeout(() => { t.hidden = true; }, 2800); }
let breathIv = null;
function startBreathe(passId){ clearInterval(breathIv); S.breathT = 0; S.sheet = { type: 'breathe', pass: passId || null }; render(); breathIv = setInterval(() => { S.breathT++; if (S.breathT >= 60) clearInterval(breathIv); if (S.sheet && S.sheet.type === 'breathe') renderSheetOnly(); }, 1000); }
function renderSheetOnly(){ keepFocus(renderSheet); }
function needSloth(){ if (mySloth()) return true; S.sheet = { type: S.authed ? 'profile' : 'join' }; render(); return false; }
function closeSheet(){ clearInterval(breathIv); S.sheet = null; S.err = ''; render(); }
root.addEventListener('click', (e) => {
  const el = e.target.closest('[data-act]'); if (!el) return;
  const a = el.dataset.act;
  if (a === 'tab'){ S.tab = el.dataset.tab; S.sheet = S.sheet && S.sheet.type === 'reveal' ? null : S.sheet; render(); window.scrollTo(0, 0); }
  else if (a === 'frames'){ S.frames = !S.frames; try { localStorage.setItem('sp-frames', S.frames ? 'on' : 'off'); } catch (er) {} render(); }
  else if (a === 'join'){ S.joinMode = el.dataset.mode || 'signup'; S.err = ''; S.sheet = { type: 'join' }; render(); }
  else if (a === 'joinmode'){ S.joinMode = S.joinMode === 'signup' ? 'signin' : 'signup'; S.err = ''; renderSheetOnly(); }
  else if (a === 'google') googleAuth();
  else if (a === 'reset') resetPass();
  else if (a === 'profile'){ S.err = ''; S.sheet = { type: S.authed ? 'profile' : 'join' }; render(); }
  else if (a === 'signout'){ if (S.auth) S.auth.signOut(); }
  else if (a === 'filter'){ S.filter = el.dataset.v; S.gshow = 24; render(); }
  else if (a === 'more'){ S.gshow += 24; render(); }
  else if (a === 'detail'){ S.sheet = { type: 'detail', n: +el.dataset.n }; render(); }
  else if (a === 'closesheet') closeSheet();
  else if (a === 'quote'){ S.quote++; render(); }
  else if (a === 'mood'){ const v = el.dataset.v; S.moods = S.moods.includes(v) ? S.moods.filter((m) => m !== v) : S.moods.concat(v); render(); }
  else if (a === 'post') post();
  else if (a === 'zzz') vote(el.dataset.id);
  else if (a === 'sheet'){ if (needSloth()){ S.sheet = { type: el.dataset.sheet }; render(); } }
  else if (a === 'ptype'){ S.send.type = el.dataset.v; renderSheetOnly(); }
  else if (a === 'clearto'){ S.send.to = null; renderSheetOnly(); }
  else if (a === 'sendpass') sendPass();
  else if (a === 'openpass'){ S.sheet = { type: 'pass', id: el.dataset.id }; render(); }
  else if (a === 'breathe'){ if (needSloth()) startBreathe(el.dataset.pass); }
  else if (a === 'finishbreathe') finishBreathe();
});
root.addEventListener('input', (e) => {
  const t = e.target;
  if (t.id === 'ponder') S.ponder = t.value;
  else if (t.id === 'lookup') S.lookup = t.value;
  else if (t.id === 'pnote') S.send.note = t.value;
  else if (t.id === 'to-num') S.send.num = t.value;
});
root.addEventListener('submit', (e) => {
  const f = e.target.dataset.form; if (!f) return; e.preventDefault();
  if (f === 'lookup'){ const n = parseInt(S.lookup, 10); if (n >= 1 && n <= TOTAL){ S.sheet = { type: 'detail', n }; render(); } else toast('Enter a number from 1 to 10,000.'); }
  else if (f === 'email') emailAuth(e.target);
  else if (f === 'profile') submitProfile(e.target);
  else if (f === 'findto') findRecipient();
});
$sheet.addEventListener('click', (e) => { if (e.target === $sheet) closeSheet(); });
document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && S.sheet) closeSheet(); });

// ---------- Boot ----------
render();
const unsubs = [];
function stopUserListeners(){ while (unsubs.length) { try { unsubs.pop()(); } catch (e) {} } }
function startDemo(){
  S.demo = true; S.ready = true; S.uid = null; S.adopted = 1284; S.community = 3612;
  const now = Date.now();
  S.posts = [[412, 'Lou', 'Napped and read in bed.', 'Sundays should be two days long', 6], [2290, 'Priya', 'Cloud-watched.', '', 4], [7781, 'Sam', 'Long lunch and said no.', 'The inbox can wait', 3]].map((x, i) => ({ id: 'demo' + i, uid: 'demo-' + i, slothNo: x[0], name: x[1], what: x[2], ponder: x[3], at: now - (i + 1) * 3600e3, zzz: Object.fromEntries(Array.from({ length: x[4] }, (_, k) => ['u' + k, true])) }));
  render();
}
function boot(){
  const fb = window.firebase, c = CFG.firebase || {};
  if (!fb || !c.apiKey || !c.projectId){ startDemo(); return; }
  try { fb.initializeApp(c); } catch (e) { if (!/already exists/.test(String(e && e.message))) { console.warn('[slothpass] Firebase failed to start', e); startDemo(); return; } }
  S.fs = fb.firestore(); S.auth = fb.auth();
  S.fs.doc('stats/register').onSnapshot((d) => { S.adopted = (d.exists && d.data().count) || 0; if (S.ready) render(); }, () => {});
  S.fs.doc('stats/community').onSnapshot((d) => { S.community = (d.exists && d.data().minutes) || 0; if (S.ready) render(); }, () => {});
  S.fs.collection('posts').orderBy('at', 'desc').limit(200).onSnapshot((snap) => { S.posts = snap.docs.map((d) => Object.assign({ id: d.id }, d.data({ serverTimestamps: 'estimate' }))); if (S.ready) render(); }, (e) => console.warn('[slothpass] feed', e));
  S.auth.onAuthStateChanged(async (u) => {
    stopUserListeners(); S.me = null; S.profile = null; S.passes = [];
    if (!u){ S.uid = null; S.authed = false; S.ready = true; render(); return; }
    S.uid = u.uid; S.authed = true;
    let first = true;
    unsubs.push(S.fs.doc('members/' + u.uid).onSnapshot((d) => {
      S.me = d.exists ? d.data({ serverTimestamps: 'estimate' }) : null;
      if (first){ first = false; S.ready = true; if (!S.me && (!S.sheet || S.sheet.type === 'join')){ S.err = ''; S.sheet = { type: 'profile' }; } else if (S.me && S.sheet && S.sheet.type === 'join') S.sheet = null; }
      render();
    }, () => { S.ready = true; render(); }));
    unsubs.push(S.fs.doc('members/' + u.uid + '/private/profile').onSnapshot((d) => { S.profile = d.exists ? d.data() : null; }, () => {}));
    unsubs.push(S.fs.collection('passes').where('to', '==', u.uid).onSnapshot((snap) => { S.passes = snap.docs.map((d) => Object.assign({ id: d.id }, d.data({ serverTimestamps: 'estimate' }))); render(); }, () => {}));
  });
  setTimeout(() => { if (!S.ready){ S.ready = true; render(); } }, 7000);
}
boot();